import {
  Button,
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const sides = ["right", "left", "top", "bottom"] as const;

export function SheetDemo() {
  return (
    <Section
      id="sheet"
      title="Sheet"
      description="Side-anchored panel. Renders from any edge."
    >
      <VariantBlock label="Sides">
        {sides.map((side) => (
          <Sheet key={side}>
            <SheetTrigger asChild>
              <Button variant="outline" size="sm" className="capitalize">
                {side}
              </Button>
            </SheetTrigger>
            <SheetContent side={side}>
              <SheetHeader>
                <SheetTitle className="capitalize">{side} sheet</SheetTitle>
                <SheetDescription>
                  Slides in from the {side}. Press esc or click outside to
                  dismiss.
                </SheetDescription>
              </SheetHeader>
              <SheetFooter>
                <Button variant="outline">Done</Button>
              </SheetFooter>
            </SheetContent>
          </Sheet>
        ))}
      </VariantBlock>
    </Section>
  );
}
